import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMedicineTablett: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconMedicineTablett"><Path d="M11.9986 4.50057L4.49861 12.0006C2.42755 14.0716 2.42755 17.4295 4.49861 19.5006C6.56968 21.5716 9.92755 21.5716 11.9986 19.5006L19.4986 12.0006C21.5697 9.9295 21.5697 6.57163 19.4986 4.50057C17.4275 2.4295 14.0697 2.4295 11.9986 4.50057Z" stroke="currentColor" strokeWidth="1.5"/><Path d="M8.5 8.5L15.5 15.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
});

export default IconMedicineTablett;
